import React from "react";
import {
  Drawer,
  IconButton,
  IconButtonProps,
  Menu,
  MenuList,
} from "@mui/material";
import { MenuAnchorReturn } from "@tlc/ui/menu/useMenuAnchor";
import { useIsMobile } from "../useIsMobile";
import { MoreHoriz } from "@mui/icons-material";
import { MoreVert } from "@mui/icons-material";

// TODO see if we can enforce children as MenuItems with types
interface OverflowMenuProps extends MenuAnchorReturn, IconButtonProps {
  /**
   * Must be an array of unwrapped MenuItem components
   */
  children: React.ReactNode;
  iconOrientaion?: "vertical" | "horizontal";
  outlined?: boolean;
}
export const OverflowMenu = React.forwardRef<
  HTMLButtonElement,
  OverflowMenuProps
>(function ExtendSearchSiteMenu(
  {
    children,
    triggerProps,
    menuProps,
    closeMenu,
    iconOrientaion,
    outlined,
    sx,
    ...props
  },
  ref,
) {
  //   const { triggerProps, menuProps, closeMenu } = useMenuAnchor(`menu-${index}`);
  const isMobile = useIsMobile();

  // when we're not using a popover, no need for anchorEl
  const { open, anchorEl, ...restMenuProps } = menuProps;
  const outlinedSx = {
    border: 1,
    borderColor: "divider",
    ...sx,
  };
  const iconButtonSx = outlined ? outlinedSx : sx;

  return (
    <>
      <IconButton
        sx={iconButtonSx}
        ref={ref}
        {...(triggerProps as IconButtonProps)}
        {...props}
      >
        {iconOrientaion === "vertical" ? <MoreVert /> : <MoreHoriz />}
      </IconButton>
      {isMobile ? (
        <Drawer open={open} anchor="bottom" onClose={closeMenu}>
          <MenuList autoFocusItem={open} {...restMenuProps}>
            {children}
          </MenuList>
        </Drawer>
      ) : (
        <Menu {...menuProps}>{children}</Menu>
      )}
    </>
  );
});
